import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Auth from '../Components/auth';
import { FaCoins } from 'react-icons/fa';

function Directincome() {
    const [transactions, setTransactions] = useState([]);
    const [totalsIncome, setTotalIncome] = useState('0');

    const userId = localStorage.getItem('id'); // or wherever you're storing it

    useEffect(() => {
        if (userId) {
            axios.get(`https://rainocoin.com/api/directincome.php?userid=${userId}`)
                .then(response => {
                    if (response.data.status) {
                        setTransactions(response.data.directIncome || []);
                        setTotalIncome(response.data.totalIncome || '0');
                    }
                })
                .catch(error => {
                    console.error("Error fetching transactions:", error);
                });
        }
    }, [userId]);

    return (
        <div>
            <Auth />
            <div className="header is-fixed">
                <div className="tf-container">
                    <div className="tf-statusbar d-flex justify-content-center align-items-center">
                        <Link to="/" className="back-btn"> <i className="icon-left" /> </Link>
                        <h3>Referral Income</h3>
                    </div>
                </div>
            </div>

            <div id="app-wrap">
                <div className="card-body">
                    <div className="card card-body bg-white rounded shadow-sm">
                        <div className="row">
                            <div className="col-6">
                                <h5>Total Income</h5>

                            </div>
                            <div className="col-6 text-end">
                                <h5>${parseFloat(totalsIncome).toFixed(2)}</h5>

                            </div>

                        </div>
                    </div>
                </div>

                {/* Transaction List */}
                <div className="app-section st1 mt-1 mb-5 bg_white_color">
                    <div className="tf-container">
                        <div className="trading-month">
                            <div className="group-trading-history mb-5">
                                {transactions.map((tx, index) => (
                                    <div key={index} className="tf-trading-history">
                                        <div className="inner-left">
                                            <div className="icon-box">
                                                <FaCoins />
                                            </div>
                                            <div className="content">
                                                <h4>{tx.user_name}</h4>
                                                <p>Stake : ${tx.stake_amount}</p>
                                            </div>
                                        </div>
                                        <span className={`num-val ${tx.type === 'debit' ? 'critical_color' : 'success_color'}`}>
                                            {tx.type === 'debit' ? '-' : '+ $'} {parseFloat(tx.reward_amount).toFixed(2)}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer (unchanged) */}
            {/* ... footer code continues ... */}
        </div>
    );
}

export default Directincome